export default "__VITE_ASSET__ifDb8Nyz__"